import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type {
    BariPreSecretarialAssistantMedScreeningReportBaseReadLabel,
    BariPreSecretarialAssistantMedScreeningReportReadSectionTitle,
} from '../bariPreSecretarialAssistantMedScreeningReportReadSections';
import type { BariPreSecretarialAssistantMedScreeningReportDataV2 } from './bariPreSecretarialAssistantMedScreeningReportDataV2';
import { biometrischeGegevensReadSection } from '../bariPreSecretarialAssistantMedScreeningReportReadSections';

export type BariPreSecretarialAssistantMedScreeningReportReadDataV2 =
    BariPreSecretarialAssistantMedScreeningReportDataV2 & {
        gewicht_lengte_bmi: string[];
    };

export type BariPreSecretarialAssistantMedScreeningReportReadKeyV2 =
    keyof BariPreSecretarialAssistantMedScreeningReportReadDataV2;

export type BariPreSecretarialAssistantMedScreeningReportReadLabelV2 =
    | BariPreSecretarialAssistantMedScreeningReportBaseReadLabel
    | 'Tabak gebruik'
    | 'Toelichting tabak';

export type BariPreSecretarialAssistantMedScreeningReportReadSectionTitleV2 =
    BariPreSecretarialAssistantMedScreeningReportReadSectionTitle;

export const bariPreSecretarialAssistantMedScreeningReportReadSchemaV2: TypedReadSchema<
    BariPreSecretarialAssistantMedScreeningReportReadKeyV2,
    BariPreSecretarialAssistantMedScreeningReportReadLabelV2,
    BariPreSecretarialAssistantMedScreeningReportReadSectionTitleV2
>[] = [
    biometrischeGegevensReadSection,
    {
        items: [
            { key: 'alcohol', label: 'Alcohol', type: 'boolean' },
            { key: 'alcohol_aantal_eenheden_per_week', label: 'Aantal eenheden', type: 'number' },
            { key: 'alcohol_toelichting', label: 'Toelichting alcohol' },
            { key: 'tabak_gebruik', label: 'Tabak gebruik' },
            { key: 'tabak_toelichting', label: 'Toelichting tabak' },
            { key: 'drugs', label: 'Drugs', type: 'boolean' },
            { key: 'drugs_toelichting', label: 'Toelichting drugs' },
        ],
        sectionTitle: 'Intoxicaties',
    },
];
